<template>
  <b-modal id="pos-detail-popup" v-model="internalShow" hide-footer centered :title="data.name" size="md" body-class="p-0 overflow-hidden" lazy @shown="handleShown">
    <div class="w-100" v-if="internalShow && data">
       <!-- SLIDER -->
       <div class="w-100 position-relative" v-if="data.slider_image && data.slider_image.length > 0">
         <template v-if="data.slider_image.length > 1">
           <flickity v-if="internalShow" ref="popup_main_slider" :options="$basic_slider_option" class="spa-product">
             <div class="carousel-cell w-100" :id="'slider-'+index"
               v-for="(slider_merchant,index) in  data.slider_image" :key="index">
               <div class="w-100" style="height: 300px;">
                 <img @click="setActiveImage(index)" :src="slider_merchant.image_url"
                   class="img-fit cursor-zoom" :alt="data.name">
               </div>
             </div>
           </flickity>
           <div class="concierge-slider-btn right" @click="clickButtonSlider('next')">
             <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
               <circle cx="16.5" cy="16.5" r="16" fill="white" stroke="#D9D9D9" />
               <path
                 d="M20 16.5202C20 16.3324 19.9249 16.1446 19.7821 16.0169L13.8253 10.2028C13.6976 10.0751 13.5324 10 13.3446 10C12.954 10 12.6535 10.293 12.6535 10.6836C12.6535 10.8714 12.7286 11.0441 12.8488 11.1719L18.7305 16.9258V16.1221L12.8488 21.8761C12.7286 21.9962 12.6535 22.169 12.6535 22.3643C12.6535 22.7549 12.954 23.0479 13.3446 23.0479C13.5324 23.0479 13.6976 22.9728 13.8329 22.8451L19.7821 17.031C19.9249 16.8883 20 16.7155 20 16.5202Z"
                 fill="black" fill-opacity="0.85" />
             </svg>
           </div>
           <div class="concierge-slider-btn left" @click="clickButtonSlider('previous')">
             <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
               <circle cx="16.5" cy="16.5" r="16" fill="white" stroke="#D9D9D9" />
               <path
                 d="M12.6535 16.5277C12.6535 16.7155 12.7286 16.9033 12.8714 17.031L18.8282 22.8451C18.9559 22.9728 19.1211 23.0479 19.3089 23.0479C19.6995 23.0479 20 22.7549 20 22.3643C20 22.1765 19.9249 22.0038 19.8047 21.876L13.923 16.1221V16.9258L19.8047 11.1718C19.9249 11.0516 20 10.8789 20 10.6836C20 10.293 19.6995 10 19.3089 10C19.1211 10 18.9559 10.0751 18.8207 10.2028L12.8714 16.0169C12.7286 16.1596 12.6535 16.3324 12.6535 16.5277Z"
                 fill="black" fill-opacity="0.85" />
             </svg>
           </div>
         </template>
         <template v-else>
           <div class="w-100" style="height:300px">
             <img @click="setActiveImage(0)" :src="data.slider_image[0].image_url" class="img-fit" :alt="data.name">
           </div>
         </template>
         <CoolLightBox
           :items="data.slider_image"
           srcName="image_url"
           :index="active_image"
           closeOnClickOutsideMobile
           @close="active_image = null">
         </CoolLightBox>
       </div>

       <div class="w-100 p-4 pt-0 mt-3">
         <div class="row">
           <div class="col-10">
             <p class="heading-6-1 mb-1">{{ data.name }}</p>
             <p class="body-2 mb-2 color-grey" v-if="data.location">{{ data.location }}</p>
           </div>
           <div class="col-2 text-right" v-if="data.star">
             <div class="d-flex justify-content-end mt-1">
                <svg class="align-self-center mr-1" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.4525 8.35339C10.3014 8.49981 10.232 8.71156 10.2664 8.91922L10.785 11.7892C10.8287 12.0325 10.726 12.2786 10.5225 12.4192C10.323 12.5651 10.0575 12.5826 9.83996 12.4659L7.25637 11.1184C7.16654 11.0706 7.06679 11.0449 6.96471 11.042H6.80662C6.75179 11.0501 6.69812 11.0676 6.64912 11.0945L4.06496 12.4484C3.93721 12.5126 3.79254 12.5353 3.65079 12.5126C3.30546 12.4472 3.07504 12.1182 3.13162 11.7711L3.65079 8.90114C3.68521 8.69172 3.61579 8.47881 3.46471 8.33006L1.35829 6.28839C1.18212 6.11747 1.12087 5.86081 1.20137 5.62922C1.27954 5.39822 1.47904 5.22964 1.71996 5.19172L4.61912 4.77114C4.83962 4.74839 5.03329 4.61422 5.13246 4.41589L6.40996 1.79672C6.44029 1.73839 6.47937 1.68472 6.52662 1.63922L6.57912 1.59839C6.60654 1.56806 6.63804 1.54297 6.67304 1.52256L6.73662 1.49922L6.83579 1.45839H7.08137C7.30071 1.48114 7.49379 1.61239 7.59471 1.80839L8.88912 4.41589C8.98246 4.60664 9.16387 4.73906 9.37329 4.77114L12.2725 5.19172C12.5175 5.22672 12.7222 5.39589 12.8033 5.62922C12.8797 5.86314 12.8138 6.11981 12.6341 6.28839L10.4525 8.35339Z" fill="#F68611" />
                </svg>
                <p class="mb-0 body-3-1 align-self-center">{{ data.star }}</p>
             </div>
           </div>
         </div>

         <div class="w-100 border-t-form pt-3 mb-4">
            <p class="body-2">{{ data.description }}</p>
         </div>

         <div class="w-100 pt-3 border-t-form">
            <p class="body-1-4 mb-3">Opening Hours</p>
            <template v-if="data.use_daily_operational_hour">
              <div class="d-flex justify-content-between mb-2 pb-2 border-b-form-dashed" v-for="day in daily_hour" :key="day.title">
                 <p class="body-2 mb-0" :class="day.is_today ? 'text-green font-bold' : ''">{{ day.title }} <span v-if="day.is_today">(Today)</span></p>
                 <div class="text-right">
                    <p class="body-2-4 mb-0" v-if="day.is_open">{{ $customFormatDateTime(day.time_start,'HH:mm:ss','HH:mm') }} - {{ $customFormatDateTime(day.time_end,'HH:mm:ss','HH:mm') }}</p>
                    <p class="body-2-1 text-danger mb-0" v-else>Closed</p>
                 </div>
              </div>
            </template>
            <div class="d-flex justify-content-between" v-else>
               <p class="body-2 mb-0">Everyday</p>
               <p class="body-2-4 mb-0">{{ $customFormatDateTime(data.time_start,'HH:mm:ss','HH:mm') }} - {{ $customFormatDateTime(data.time_end,'HH:mm:ss','HH:mm') }}</p>
            </div>
         </div>
       </div>
    </div>
  </b-modal>
</template>

<script>
import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
import moment from 'moment';

export default {
  components: {
    CoolLightBox
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      active_image: null
    }
  },
  computed: {
    internalShow: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    daily_hour() {
      if (!this.data.use_daily_operational_hour) return [];

      const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
      const today = moment().format('dddd').toLowerCase();

      return days.map(day => {
        return {
          title: this.$capitalize(day),
          is_open: this.data[`sale_${day}`],
          time_start: this.data[`time_start_${day}`],
          time_end: this.data[`time_end_${day}`],
          is_today: today === day
        };
      });
    }
  },
  methods: {
    setActiveImage(index) {
      this.active_image = index
    },
    clickButtonSlider(type) {
      if (type == 'next') this.$refs.popup_main_slider.next()
      else this.$refs.popup_main_slider.previous()
    },
    handleShown() {
      setTimeout(() => {
        if (this.$refs.popup_main_slider) {
          this.$refs.popup_main_slider.resize();
        }
      }, 100);
    }
  }
}
</script>

<style scoped>
.color-grey {
  color: #757575;
}
.border-b-form-dashed {
  border-bottom: 1px dashed #EEE;
}
.border-b-form-dashed:last-child {
  border-bottom: none;
}
</style>



// WEBPACK FOOTER //
// src/components/hotel/concierge/pos/PosDetailPopup.vue